import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuaranteComponent } from '../guarante/guarante.component';
import { ShipmentComponent } from '../shipment/shipment.component';
import { UserManagementComponent } from '../user-management/user-management.component';
import { HomeComponent } from './home.component';

const routes: Routes = [
  {
    path: '', component: HomeComponent, 
    children: [

      { path: 'shipment', component: ShipmentComponent ,data: {title: 'Shipments'}},
      { path: 'guarantee', component: GuaranteComponent , data: {title: 'Guarantee'}}
     

    ]

  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
